import { render, staticRenderFns } from "./ProductVideo.vue?vue&type=template&id=569debba&"
import script from "./ProductVideo.vue?vue&type=script&lang=js&"
export * from "./ProductVideo.vue?vue&type=script&lang=js&"
import style0 from "./ProductVideo.vue?vue&type=style&index=0&id=569debba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports